import React from 'react';
import {
  View,
  Text,
  TextInput,
  StyleSheet,
} from 'react-native';
import { MARKETPLACE_COLORS } from '@/constants/residents/marketplaceColors';
import { StepHeader, ToggleBar, maintenanceStepStyles } from './shared';

interface StepAdditionalProps {
  hasPets: boolean;
  onHasPetsChange: (value: boolean) => void;
  specialInstructions: string;
  onSpecialInstructionsChange: (value: string) => void;
}

/**
 * StepAdditional - Step 6: Additional Information
 * Allows user to specify pets and special entry instructions
 */
export const StepAdditional: React.FC<StepAdditionalProps> = ({
  hasPets,
  onHasPetsChange,
  specialInstructions,
  onSpecialInstructionsChange,
}) => {
  const toggleIndex = hasPets ? 0 : 1;

  const handleToggleChange = (index: number) => {
    onHasPetsChange(index === 0);
  };

  return (
    <View style={maintenanceStepStyles.container}>
      <StepHeader title="Additional" />
      
      <View style={maintenanceStepStyles.content}>
        {/* Pets Question */}
        <View style={styles.section}>
          <Text style={styles.questionText}>Do you have pets?</Text>
          <ToggleBar
            options={['Yes', 'No']}
            selectedIndex={toggleIndex}
            onSelect={handleToggleChange}
          />
        </View>

        {/* Special Entry Instructions */}
        <View style={styles.section}>
          <View style={styles.inputContainer}>
            <TextInput
              style={styles.inputText}
              value={specialInstructions}
              onChangeText={onSpecialInstructionsChange}
              placeholder="Special entry instructions"
              placeholderTextColor={MARKETPLACE_COLORS.textSecondary}
              maxLength={500}
              autoCapitalize="sentences"
            />
          </View>
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  section: {
    gap: 16,
  },
  questionText: {
    fontSize: 16,
    fontWeight: '400',
    color: MARKETPLACE_COLORS.textPrimary,
    lineHeight: 24,
  },
  inputContainer: {
    backgroundColor: MARKETPLACE_COLORS.inputBackground,
    borderWidth: 1,
    borderColor: MARKETPLACE_COLORS.inputBorder,
    borderRadius: 8,
    height: 40,
    paddingHorizontal: 16,
    justifyContent: 'center',
  },
  inputText: {
    fontSize: 14,
    fontWeight: '400',
    color: MARKETPLACE_COLORS.textPrimary,
    lineHeight: 17.5,
  },
});

export default StepAdditional;
